import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const [particles, setParticles] = useState<Array<{left: number, delay: number, duration: number, size: number}>>([]);

  useEffect(() => {
    const particleArray = Array.from({ length: 100 }, () => ({
      left: Math.random() * 100,
      delay: Math.random() * 15,
      duration: 8 + Math.random() * 10,
      size: 2 + Math.random() * 6
    }));
    setParticles(particleArray);
  }, []);

  return (
    <div className="not-found-page">
      {/* Animated Particles */}
      <div className="nf-particles">
        {particles.map((p, i) => (
          <div
            key={i}
            className="nf-particle"
            style={{
              left: `${p.left}%`,
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
              width: `${p.size}px`,
              height: `${p.size}px`
            }}
          />
        ))}
      </div>

      <div className="nf-container">
        {/* Logo Section */}
        <div className="nf-logo">
          <img src="/public/assets/images/paylogo.png" alt="CineClubs Logo" />
          <div className="nf-logo-text">
            <span className="nf-brand">CINECLUBS</span>
            <span className="nf-tagline">Stream Together</span>
          </div>
        </div>

        {/* 404 Number */}
        <div className="nf-number">
          <div className="nf-glow glow1"></div>
          <div className="nf-glow glow2"></div>
          <div className="nf-glow glow3"></div>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="350 447.4 323.9 129.2">
            <g className="nf-zero">
              <path d="M484.7,570.5c-13.3-13.3-15.7-29.6-16.4-46.3c-0.7-16.1-0.7-32.1,4-47.8c4.4-14.5,13.3-24.6,28.4-27.6
                c15.5-3.1,30.2-1.5,41.9,10.9c6.2,6.6,9.2,14.8,10.7,23.6c3.8,22.9,4.2,45.8-2.3,68.4c-2,7.1-6.2,12.9-11.3,18.1
                c-0.4,0.4-0.7,0.6-1.4,0.8c0.4,0.1,4.4,0,4.5,0c6.9,0.1,13.7-0.1,20.6-0.1c2.1,0,3.9,0.4,3.9,3c0,2.4-1.5,3.1-3.8,3.1
                c-12.2,0-24.4,0-36.5,0c-2,0-3.4-0.4-3.8-2.7c-0.4-2.1,0.9-3,2.6-3.6c9.8-3.2,15.6-10.2,19-19.6c3.2-8.8,4.3-17.9,4.6-27.1
                c0.5-16.9,1-33.8-5.3-50c-3.6-9.4-10.3-16.2-20.1-18.4c-14-3.2-27.6-2.8-38.3,8.9c-6,6.6-8.3,14.9-9.6,23.3c-2.6,18-2.6,36,0.5,54
                c0.8,4.6,2.3,9.2,4.3,13.5c3.6,7.5,9.2,12.8,17.2,15.4c1.9,0.6,3.2,1.4,2.9,3.7c-0.4,2.2-1.9,2.5-3.9,2.5c-12.1,0-24.1,0-36.2,0
                c-2.3,0-4.1-0.4-4.2-3c0-2.8,2-3.1,4.2-3.1C468.4,570.4,476.1,570.5,484.7,570.5z"/>
            </g>
            <g className="nf-four nf-four-left">
              <path d="M433.9,570.6c0-8,0-15,0-22c4,0,8.3,0,12.5,0c2.5,0,3.5-1.5,3.5-4c0-4,0-7.9,0-11.9c0-2.4-1-3.2-3.5-3.3
                c-1.3-0.1-2.6,0.2-3.9,0.2c-2.8,0-5.6,0-8.4,0c-0.7-1-0.2-2.2-0.2-3c0-23.9,0-47.7,0-71.6c0-0.8,0-1.6,0-2.4c-0.3-2.1-1.3-3-3.3-3
                c-3.8,0-7.7,0.1-11.5-0.1c-1.6-0.1-2.5,0.6-3.2,1.7c-4,6.6-8.7,12.7-13,19c-3.7,5.4-7.5,10.7-11.3,16c-3.2,4.5-6.3,9.3-9.5,13.8
                c-2.6,3.7-5.1,7.5-7.8,11.1c-2.8,3.8-5.4,7.7-8.1,11.6c-1.4,2-2.8,4.1-4.3,6c-0.7,0.8-1,1.6-1,2.5c0,4.7,0,9.3,0,14
                c0,2.8,0.4,3.4,3.2,3.4c15.8,0,31.7,0,47.5,0c0.6,0,1.3,0,2.3,0c0,7,0,14.4,0,22c-2,0-2.7,0-3.9,0c-18.2,0-36.3,0-54.5,0
                c-0.7,0-1.4,0-2.1,0c-2.3,0.2-3.4,1-3.4,3c0,2.1,1.1,3,3.6,3c19.9,0,39.8,0,59.7,0c1.2,0,2.3,0,3.5,0c2,0,3.1-0.8,3.1-2.9
                c0-9.4,0-18.9,0-28.3c0-2.2-0.9-3.5-3.1-3.7c-0.8-0.1-1.6-0.1-2.4-0.1c-14.7,0-29.3,0-44,0c-0.9,0-1.5,0-2.5,0c0-1,0-3.1,0-4.7
                c0-1.7-0.5-3.6,0.1-5.1c0.8-1.9,2.1-3.6,3.5-5.1c2-2.3,3.2-5,5.1-7.4c2.4-3,4.4-6.4,6.7-9.5c3.4-4.5,6.4-9.2,9.5-13.8
                c2.1-3,4.2-5.9,6.3-8.9c0.9-1.3,1.6-2.6,2.5-3.9c4.2-5.9,8.3-11.9,12.4-17.9c2-2.8,3.7-6,6-8.6c0.3-0.4,0.3-1.1,1-1.1c2.2,0,4,0,7,0
                c0,2,0,2.9,0,4c0,23.7,0,47.5,0,71.2c0,0.7,0,1.4,0,2.1c0,1.5,1,2.7,2.6,2.7c4.3,0,8.4,0,13.4,0c0,2.1,0,4,0,6c-4,0-7.4,0-10.9,0
                c-0.7,0-1.4,0-2.1,0c-2.4,1-3,1.5-3,3.9c0,9.3,0,18.6,0,27.9c0,2.5,0.6,3.2,3.2,3.2c9.1,0,18.2,0,27.2,0c1.2,0,2.2,0.1,2.8-1.3
                c0.8-1.7,0.9-2.1-0.1-3.5c-0.7-0.9-1.6-1.2-2.8-1.2c-1.5,0-3,0-4.5,0C447.1,570.6,440.9,570.6,433.9,570.6z"/>
            </g>
            <g className="nf-four nf-four-right">
              <path d="M590,570.6c0-8,0-15,0-22c-4,0-8.2,0-12.4,0c-2.5,0-3.6-1.5-3.6-4c0-4,0-7.9,0-11.9c0-2.4,1.1-3.2,3.6-3.3
                c1.3-0.1,2.7,0.2,3.9,0.2c2.8,0,5.6,0,8.4,0c0.7-1,0.1-2.2,0.1-3c0-23.9,0-47.7,0-71.6c0-0.8,0-1.6,0.1-2.4c0.3-2.1,1.3-3,3.3-3
                c3.8,0,7.7,0.1,11.5-0.1c1.6-0.1,2.5,0.6,3.2,1.7c4,6.6,8.7,12.7,13,19c3.7,5.4,7.5,10.7,11.3,16c3.2,4.5,6.3,9.3,9.5,13.8
                c2.6,3.7,5.1,7.5,7.8,11.1c2.8,3.8,5.4,7.7,8.1,11.6c1.4,2,2.7,4.1,4.2,6c0.7,0.8,0.9,1.6,0.9,2.5c0,4.7,0,9.3,0,14
                c0,2.8-0.3,3.4-3.1,3.4c-15.8,0-31.7,0-47.5,0c-0.6,0-1.4,0-2.4,0c0,7,0,14.4,0,22c2,0,2.8,0,4,0c18.2,0,36.3,0,54.5,0
                c0.7,0,1.4,0,2.1,0c2.3,0.2,3.4,1,3.4,3c0,2.1-1.1,3-3.6,3c-19.9,0-39.8,0-59.7,0c-1.2,0-2.3,0-3.5,0c-2,0-3.2-0.8-3.2-2.9
                c0-9.4,0-18.9,0-28.3c0-2.2,0.9-3.5,3.1-3.7c0.8-0.1,1.7-0.1,2.5-0.1c14.7,0,29.3,0,44,0c0.9,0,1.4,0,2.4,0c0-1,0-3.1,0-4.7
                c0-1.7,0.6-3.6,0-5.1c-0.8-1.9-2.1-3.6-3.5-5.1c-2-2.3-3.2-5-5.1-7.4c-2.4-3-4.4-6.4-6.7-9.5c-3.4-4.5-6.4-9.2-9.5-13.8
                c-2.1-3-4.2-5.9-6.3-8.9c-0.9-1.3-1.6-2.6-2.5-3.9c-4.2-5.9-8.3-11.9-12.4-17.9c-2-2.8-3.7-6-6-8.6c-0.3-0.4-0.3-1.1-1-1.1
                c-2.2,0-4.1,0-7.1,0c0,2,0,2.9,0,4c0,23.7,0,47.5,0,71.2c0,0.7,0,1.4,0,2.1c0,1.5-0.9,2.7-2.5,2.7c-4.3,0-8.5,0-13.5,0
                c0,2.1,0,4,0,6c4,0,7.5,0,11,0c0.7,0,1.4,0,2.1,0c2.4,1,2.9,1.5,2.9,3.9c0,9.3,0,18.6,0,27.9c0,2.5-0.5,3.2-3.1,3.2
                c-9.1,0-18.2,0-27.2,0c-1.2,0-2.2,0.1-2.8-1.3c-0.8-1.7-0.9-2.1,0.1-3.5c0.7-0.9,1.6-1.2,2.8-1.2c1.5,0,3,0,4.5,0
                C576.8,570.6,583,570.6,590,570.6z"/>
            </g>
          </svg>
        </div>

        {/* Message */}
        <div className="nf-message">
          <h1>Oops! Page Not Found</h1>
          <p>The page you're looking for doesn't exist or has been moved. Let's get you back home.</p>
        </div>

        {/* Home Button */}
        <Link to="/" className="nf-home-btn">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
          </svg>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
